import { useEffect, useState } from "react";
import { logOut, refreshToken } from "../Services/User.js";
import { refreshCheck } from "../Services/TokenRefresh.js";

//Login
import Lform from "./Login/LForm.jsx";
import jwt from 'jwt-decode';

//Home
import MainFrame from "./MainFrame/MainFrame.jsx";
import elementContains from "../utils/moment/DOM/elementContains.js";



function App() {

  const [isLoged, setIsLoged] = useState(false);
  const [usrData, setUsrData] = useState({});
  const [actualFrame, setActualFrame] = useState('home');
  const [sidebarState, setSidebarState] = useState(() => window.innerWidth > 900 ? 0 : 2);


  const checkLocalData = () => {
    let token = localStorage.getItem('access_token');

    if (token != null && token != '') {
      let tokenDecoded = jwt(token);

      const timestampMillis = Date.now();
      const timestampSeconds = Math.floor(timestampMillis / 1000);

      if(tokenDecoded.exp < timestampSeconds){
        logOut();
        window.alert('Su sesion esta expirada');
        window.location.reload();
      } 
      
      if(tokenDecoded.id_user_type != 1){
        logOut();
        window.alert('Su cuenta no tiene acceso a esta plataforma.');
      }

      setUsrData({
        dni: tokenDecoded.dni,
        name: tokenDecoded.name,
        email: tokenDecoded.email,
        userType: tokenDecoded.id_user_type,
        profilePic: tokenDecoded.url_profile_pic
      });
      setIsLoged(true);
    } else {
      setIsLoged(false);
    }
  }

  const changeFrame = (str) => {
    setActualFrame(str);
    //setSidebarState(2)
  }

  useEffect(() => {
    let queryString = new URL(window.location.href);
    let location = queryString.searchParams.get("view");

    if (location) {
      setActualFrame(location)
    }



    checkLocalData();
  }, []);

  const changeSidebarState = () => {

    if (sidebarState === 0) {
      setSidebarState(2)
    } else {
      setSidebarState(0)
    }
  }

  /* Ocultar sidebar al clickear afuera de la misma */
  useEffect(() => {
    function closeSidebar(e) {
      if (!elementContains(document.querySelector(".sidebar-container"), e.target) && window.innerWidth < 1024) {
        setSidebarState(2);
      }
    }

    window.addEventListener("click", closeSidebar);

    return () => window.removeEventListener("click", closeSidebar);
  }, [])



  if (isLoged) {
    return (
      <MainFrame usrData={usrData} actualFrame={actualFrame} setActualFrame={changeFrame} sidebarState={sidebarState} setSidebarState={setSidebarState} changeSidebarState={changeSidebarState} />
    )
  } else {
    return (
      <>
        <Lform />
      </>
    );
  }
}

export default App;
